module.exports = new __parcel__URL__("../../edj-logo-2.51fc8c44.svg").toString();